/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Failedtosendverification3Inputs */

const en_error_failedtosendverification3 = /** @type {(inputs: Error_Failedtosendverification3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send verification code`)
};

/**
* | output |
* | --- |
* | "Failed to send verification code" |
*
* @param {Error_Failedtosendverification3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const error_failedtosendverification3 = /** @type {((inputs?: Error_Failedtosendverification3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Failedtosendverification3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_failedtosendverification3(inputs)
});
export { error_failedtosendverification3 as "error_failedToSendVerification" }